import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge"

// Graphite's type sizes (tailwind.config.js) are font sizes, not text colours
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["h1", "h2", "h3", "h4", "lead"] }] } },
})

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
